/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined'
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined'
import RecordVoiceOverOutlinedIcon from '@mui/icons-material/RecordVoiceOverOutlined'
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined'
import TagOutlinedIcon from '@mui/icons-material/TagOutlined'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import React from 'react'
import { CHANNEL_COLORS, ICON, TEXT } from '../../theme/tokens'

/** Channel catalog shared by the wizard steps. */
export const CHANNELS = [
    {
        value: 'email',
        label: 'Email',
        color: CHANNEL_COLORS.EMAIL,
        icon: <EmailOutlinedIcon sx={{ fontSize: ICON.sm }} />,
    },
    {
        value: 'whatsapp',
        label: 'WhatsApp',
        color: CHANNEL_COLORS.WHATSAPP,
        icon: <WhatsAppIcon sx={{ fontSize: ICON.sm }} />,
    },
    {
        value: 'sms',
        label: 'SMS',
        color: CHANNEL_COLORS.SMS,
        icon: <SmsOutlinedIcon sx={{ fontSize: ICON.sm }} />,
    },
    {
        value: 'voice',
        label: 'Voice',
        color: CHANNEL_COLORS.VOICE,
        icon: <RecordVoiceOverOutlinedIcon sx={{ fontSize: ICON.sm }} />,
    },
    // Push and Slack pipelines exist (e.g. `free_credits_grant_slack`, the
    // `*_pn` events); without them here such pipelines could be neither
    // created nor edited.
    {
        value: 'push_notification',
        label: 'Push',
        color: CHANNEL_COLORS.PUSH_NOTIFICATION,
        icon: <NotificationsNoneOutlinedIcon sx={{ fontSize: ICON.sm }} />,
    },
    {
        value: 'slack',
        label: 'Slack',
        color: CHANNEL_COLORS.SLACK,
        icon: <TagOutlinedIcon sx={{ fontSize: ICON.sm }} />,
    },
]

export const channelMeta = (commType) =>
    CHANNELS.find((c) => c.value === commType) ?? {
        value: commType,
        label: commType || '—',
        color: TEXT.muted,
        icon: null,
    }

/** Uppercase micro-label above a form field (the overline slot). */
export const FieldLabel = ({ children }) => (
    <Typography
        variant="overline"
        component="p"
        sx={{
            color: TEXT.muted,
            lineHeight: 1.6,
            mb: 0.75,
        }}
    >
        {children}
    </Typography>
)

/** Section heading with a trailing divider line. */
export const SectionLabel = ({ children }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
        <Typography
            variant="overline"
            component="p"
            sx={{
                color: TEXT.faint,
                lineHeight: 1.6,
                whiteSpace: 'nowrap',
            }}
        >
            {children}
        </Typography>
        <Divider sx={{ flex: 1 }} />
    </Box>
)
